import z from "zod";

const translationPath = "chatBot.page.service.appointmentArrivalRule.errors.";

export const appointmentArrivalSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, { message: translationPath + "name" }),
  description: z.string().nullish(),
});

export type TAppointmentArrivalForm = z.infer<typeof appointmentArrivalSchema>;
